import React, { Dispatch, SetStateAction } from "react";

interface FiltersContextInterface {
  filters: { [x: string]: any };
  setFilters: (id: string, data: any) => void;
  resetFilters: () => void;
  setInternalFilters: Dispatch<SetStateAction<{ [x: string]: any }>>;
}

const defaultValue: FiltersContextInterface = {
  filters: {},
  setFilters: (id, data) => null,
  resetFilters: () => null,
  setInternalFilters: () => null,
};
export const FiltersContext = React.createContext(defaultValue);

export const useFilters = () => {
  return React.useContext(FiltersContext);
};
